export * from './MenuHeaderDetailsText';
